import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { green, yellow } from "@mui/material/colors";

import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import Order from "../pages/Order";

function OrderHistory(props) {
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    ...theme.applyStyles("dark", {
      backgroundColor: "#1A2027",
    }),
  }));

  return (
    <div>
      <Box
        sx={{
          height: "100dvh",
          overflowY: "auto",
          WebkitOverflowScrolling: "touch",
        }}
      >
        {" "}
        {props.orderHistory.length === 0 ? (
          <i>Your past orders will appear here once you make a purchase.</i>
        ) : (
          props.orderHistory.map((order, index) => (
            <Box
              key={index} // ✅ Fix: Added key
              component="section"
              sx={{ p: 1, textAlign: "center" }}
            >
              <Grid container direction={"column"} spacing={1}>
                <Box component="section" sx={{ p: 2 }}>
                  <Item>
                    <Grid
                      container
                      direction={"column"}
                      sx={{ p: 1 }}
                      spacing={1}
                    >
                      <Grid
                        container
                        direction={"row"}
                        sx={{
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                        }}
                      >
                        <Box sx={{ textAlign: "left" }}>
                          <h3>Order No. {order.order_id}</h3>{" "}
                          {/* ✅ Fix: Corrected variable */}
                          <i>{new Date(order.order_date).toLocaleString()}</i>
                        </Box>
                        <Grid container spacing={1}>
                          <Box>
                            <span>{order.payment_status}</span> |{" "}
                            <i>{order.order_status}</i>{" "}
                          </Box>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        direction={"row"}
                        sx={{
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                        }}
                      >
                        <Grid
                          container
                          direction={"row"}
                          sx={{
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                          }}
                        >
                          {props.cartItems[index].map((item, itemIndex) => (
                            <img
                              src={JSON.parse(item.prod_image)[0]}
                              loading="lazy"
                              alt={item.prod_name}
                              style={{
                                width: "75px",
                                height: "75px",
                                objectFit: "cover",
                              }}
                            />
                          ))}
                        </Grid>
                        <Box></Box>
                      </Grid>
                      <hr />{" "}
                      <Grid
                        container
                        direction={"row"}
                        sx={{ justifyContent: "space-between" }}
                      >
                        <Box>
                          <span>{order.order_courier}</span>
                        </Box>
                        <Box>
                          <span>Total:</span>{" "}
                          <b style={{ fontSize: "x-large" }}>
                            {" "}
                            ₱{order.total_amount.toLocaleString("fil-PH")}{" "}
                            {/* ✅ Fix: Corrected variable */}
                          </b>
                        </Box>
                      </Grid>
                    </Grid>
                  </Item>
                </Box>
              </Grid>
            </Box>
          ))
        )}
      </Box>
    </div>
  );
}
export default OrderHistory;
